import {data} from 'autoprefixer';
import comp from '../components/barrel';
import listReturnState from '../js/listReturnState';

export default {
  async prepare() {
    const vars = {};
    vars.org_uuid = this.vars.org_uuid;
    this.recipe.methods.push(await O.mPOST('communal/provinces'));
    this.recipe.methods.push(await O.mPOST('communal/div-branches'));
    this.recipe.methods.push(await O.mPOST('communal/divisions'));
    this.recipe.methods.push(await O.mPOST('communal/organisation-types'));
    this.recipe.methods.push(await O.mPOST('organisation/get-organisation-detail', vars));
  },

  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(res) {
    const back = listReturnState.take('ViewOrganisation');
    listReturnState.mountBackToListBar('Back to organisations', back);
    this.provincesData = res['communal/provinces'].data;
    this.divBranchesData = res['communal/div-branches'].data;
    this.orgTypesData = res['communal/organisation-types'].data;
    this.divisionsData = res['communal/divisions'].data.divisions;
    this.orgDetailData = res['organisation/get-organisation-detail'].data;

    const inputForm = U.id('org-form');
    inputForm.innerHTML = '';

    // =====================================
    // ORGANISATION DETAILS
    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid1.id = 'newItem';

    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsPage.showCompanyBranch()', initValue: this.orgDetailData.division_uuid});

    const compBranchDiv = U.divAtt('div', 'id', 'compBranchDiv');
    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === this.orgDetailData.division_uuid);
    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1, initValue: this.orgDetailData.division_branch_uuid});
    compBranchDiv.appendChild(compBranchDD);

    const orgTypeDD = await comp.select_v2({elID: 'orgTypeDD', ddData: this.orgTypesData, valueDataName: 'org_type_uuid', textDataName: 'short_text', labelName: 'Organisation Type', requiredYN: 1, initValue: this.orgDetailData.org_type_uuid});
    const orgName = await comp.inputText('orgName', this.orgDetailData.short_text, 'Organisation Name', 1);
    const regNumber = await comp.inputText('regNumber', this.orgDetailData.registration_num, 'Registeration Number', 1);
    const fspDiv = U.divAtt('div', 'id', 'fspDiv');

    grid1.appendChild(divisionDD);
    grid1.appendChild(compBranchDiv);
    grid1.appendChild(orgTypeDD);
    grid1.appendChild(orgName);
    grid1.appendChild(regNumber);
    grid1.appendChild(fspDiv);
    inputForm.appendChild(grid1);

    // =====================================
    // ORGANISATION BRANCH ADDING | LISTING | TOGGLING ACTIVEYN

    // Heading and hr elements
    const orgBranchHeading = U.divAtt('h6', 'class', 'mt-3');
    orgBranchHeading.innerHTML = 'Organisation Branch Details';
    const hrEl = U.divAtt('hr', 'class', 'mt-4 mb-8 h-1 bg-lightgray text-lightgray');
    // 2 column grid for listing and adding organisation branches
    const gridOrgBranch = U.divAtt('div', 'class', 'res-grid-cols-2');
    gridOrgBranch.id = 'gridOrgBranch';

    // Organisation Branch List Section
    // =====================================
    const vars = {};
    vars.org_uuid = this.orgDetailData.org_uuid;

    O.PREP([await O.mPOST('communal/org-branch-list ', vars)])
      .then(async (res) => {
        const tableData = res['communal/org-branch-list '].data;
        const orgBranchTable = await comp.table({elID: 'orgBranch'});
        // Inserting table as first child to org branch 2-column grid
        U.id('gridOrgBranch').prepend(orgBranchTable);
        return tableData;
      })
      .then(async (tableData) => {
        this.buildBranchListingTable(tableData);
      })
      .catch(() => {});

    // Adding Organisation Branches Section
    // =====================================
    const gridAddOrgBranch = U.divAtt('div', 'class', 'flex-col');
    // Subform for adding a single organisation branch
    const gridOrgBranchSubForm = U.divAtt('div', 'class', 'flex-col lg:justify-self-end lg:w-[80%]');
    gridOrgBranchSubForm.id = 'gridOrgBranchSubForm';
    // Text input for short name
    const orgBranchShortNameInput = await comp.inputText(`orgBranchShortNameInput`, '', '', 0, null, 'Organisation Branch Short Name');
    // Text input for long name
    const orgBranchLongNameInput = await comp.inputText(`orgBranchLongNameInput`, '', '', 0, null, 'Organisation Branch Long Name');
    // Add branch button for submitting subform
    const addOrgBranchBtn = U.divAtt('button', 'class', 'px-4 py-2');
    addOrgBranchBtn.innerHTML = 'Assign Branch';
    addOrgBranchBtn.id = 'addOrgBranchBtn';
    // Appending all elements responsible for adding new organisation branches;
    gridOrgBranchSubForm.appendChild(orgBranchShortNameInput);
    gridOrgBranchSubForm.appendChild(orgBranchLongNameInput);
    gridOrgBranchSubForm.appendChild(addOrgBranchBtn);
    gridAddOrgBranch.appendChild(gridOrgBranchSubForm);
    gridOrgBranch.appendChild(gridAddOrgBranch);
    inputForm.appendChild(orgBranchHeading);
    inputForm.appendChild(gridOrgBranch);
    inputForm.appendChild(hrEl);

    // Setting up click event listener for "assign branch" and "add subform" buttons
    U.id('mainContent').addEventListener('click', (e) => {
      // Assign branch button clicked
      if (e.target.id === 'addOrgBranchBtn') {
        if (U.id('orgBranchShortNameInput').value && U.id('orgBranchLongNameInput').value) {
          this.addBranchToOrg();
        } else {
          const msg = 'Please supply both input values to add a branch';
          return comp.toast_v2({msg: msg, state: 2});
        }
      }
    });

    // =====================================
    // BUSINESS ADDRESS
    const bAddress = await comp.inputText(`bAddress`, this.orgDetailData.business_address, 'Business Address', 1);
    inputForm.appendChild(bAddress);

    const grid2 = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid2.id = 'newItemBusinessAddress';

    const bSuburb = await comp.inputText(`bSuburb`, this.orgDetailData.business_suburb, 'Suburb', 1);
    const bTown = await comp.inputText(`bTown`, this.orgDetailData.business_town, 'Town/City', 1);
    const bProvinceDD = await comp.select_v2({elID: 'bProvinceDD', ddData: this.provincesData, valueDataName: 'province_uuid', textDataName: 'long_text', labelName: 'Province', requiredYN: 1, initValue: this.orgDetailData.business_province_uuid});
    const bArea = await comp.inputText(`bArea`, this.orgDetailData.business_area_code, 'Area Code', 1);
    grid2.appendChild(bSuburb);
    grid2.appendChild(bTown);
    grid2.appendChild(bProvinceDD);
    grid2.appendChild(bArea);
    inputForm.appendChild(grid2);

    // =====================================
    // POSTAL ADDRESS
    const pAddress = await comp.inputText(`pAddress`, this.orgDetailData.postal_address, 'Postal Address', 1);
    inputForm.appendChild(pAddress);

    const grid3 = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid3.id = 'newItemPostalAddress';

    const pSuburb = await comp.inputText(`pSuburb`, this.orgDetailData.postal_suburb, 'Suburb', 1);
    const pTown = await comp.inputText(`pTown`, this.orgDetailData.postal_town, 'Town/City', 1);
    const pProvinceDD = await comp.select_v2({elID: 'pProvinceDD', ddData: this.provincesData, valueDataName: 'province_uuid', textDataName: 'long_text', labelName: 'Province', requiredYN: 1, initValue: this.orgDetailData.postal_province_uuid});
    const pArea = await comp.inputText(`pArea`, this.orgDetailData.postal_area_code, 'Area Code', 1);
    grid3.appendChild(pSuburb);
    grid3.appendChild(pTown);
    grid3.appendChild(pProvinceDD);
    grid3.appendChild(pArea);
    inputForm.appendChild(grid3);

    const textarera = await comp.textarea('textarea', this.orgDetailData.notes, 'Notes', 0);
    inputForm.appendChild(textarera);
  },

  async showCompanyBranch() {
    const companyDD = U.id('companyDD').value;
    const grid1 = U.id('compBranchDiv');
    grid1.innerHTML = '';

    if (!companyDD) {
      return;
    }

    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === companyDD);

    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1});
    grid1.appendChild(compBranchDD);
  },

  async buildBranchListingTable(tableData) {
    // Building the table head
    // -------------------------------------

    const tableHead = U.id('tableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    // Created date
    const createdDateTHRow = headRow.insertCell(0);
    createdDateTHRow.innerHTML = 'Created Date';
    // Created by
    const createdByTHRow = headRow.insertCell(1);
    createdByTHRow.innerHTML = 'Created By';
    // Active toggle
    const activeTHRow = headRow.insertCell(2);
    activeTHRow.innerHTML = 'Active';
    // Short name
    const shortNameTHRow = headRow.insertCell(3);
    shortNameTHRow.innerHTML = 'Short Name';
    // Long name
    const longNameTHRow = headRow.insertCell(4);
    longNameTHRow.innerHTML = 'Long Name';

    // Building the table body
    // -------------------------------------

    const userListBody = U.id('tableBody');
    userListBody.innerHTML = '';

    // Use table data to build out table body rows
    if (tableData.length) {
      tableData.forEach(async (row, index) => {
        const userRow = userListBody.insertRow();

        // Created date
        const createdDateTBRow = userRow.insertCell(0);
        createdDateTBRow.innerHTML = row.created_date || 'N/A';
        // Created by
        const createdByTBRow = userRow.insertCell(1);
        createdByTBRow.innerHTML = row.created_by_name || 'N/A';
        // Active toggle
        const activeTBRow = userRow.insertCell(2);
        const activeYN = await comp.toggle_v2({elID: `orgBranchActiveYN${index}`, isChecked: row.active_yn, labelName: '', onToggleChange: 'thsPage.changeOrgBranchActiveYN()', elValue: row.active_yn});
        activeTBRow.appendChild(activeYN);
        // Setting vars used in request payload to toggle org branch activeYN
        thsPage.vars.org_branch_uuid = row.org_branch_uuid;
        thsPage.vars.active_yn = row.active_yn;
        // Short name
        const shortNameTBRow = userRow.insertCell(3);
        shortNameTBRow.innerHTML = row.short_text || 'N/A';
        // Long name
        const longNameTBRow = userRow.insertCell(4);
        longNameTBRow.innerHTML = row.long_text || 'N/A';
      });
    } else {
      const branchRow = userListBody.insertRow();
      const empty = branchRow.insertCell(0);
      empty.innerHTML = 'No branches available.';
      empty.colSpan = 5;
    }
  },

  async addBranchToOrg() {
    const vars = {};
    vars.org_uuid = this.orgDetailData.org_uuid;
    vars.short_name = U.id('orgBranchShortNameInput').value;
    vars.long_name = U.id('orgBranchLongNameInput').value;

    this.marketersData = [];
    O.PREP([await O.mPOST('communal/org-branch ', vars)])
      .then(async (res) => {
        res['communal/org-branch'];
        const msg = 'Branch successfully added to organisation';
        // Clear input fields
        U.id('orgBranchShortNameInput').value = '';
        U.id('orgBranchLongNameInput').value = '';

        // Confirmation popup of added org branch
        comp.toast(msg);
      })
      .then(async () => {
        // Add new branch to org branch listing table
        const vars = {};
        vars.org_uuid = this.orgDetailData.org_uuid;

        O.PREP([await O.mPOST('communal/org-branch-list ', vars)])
          .then(async (res) => {
            const tableData = res['communal/org-branch-list '].data;
            // Remove existing table
            const branchListingTableContainer = U.id('tableContainer');
            if (branchListingTableContainer) {
              branchListingTableContainer.remove();
            }
            // Create a new table with added org branch
            const orgBranchTable = await comp.table({elID: 'orgBranch'});
            // Inserting table as first child to org branch 2-column grid
            U.id('gridOrgBranch').prepend(orgBranchTable);
            return tableData;
          })
          .then(async (tableData) => {
            this.buildBranchListingTable(tableData);
          })
          .catch(() => {});
      })
      .catch(() => {});
  },

  async changeOrgBranchActiveYN() {
    const vars = {};
    vars.org_branch_uuid = thsPage.vars.org_branch_uuid;
    vars.active_yn = !thsPage.vars.active_yn;

    O.PREP([await O.mPOST('communal/org-branch-active  ', vars)])
      .then(async (res) => {
        return res['communal/org-branch-active'];
      })
      .catch(() => {});
  },

  async updateOrg() {
    if (!(await U.validateForm('org-form'))) {
      return;
    }

    const vars = {};
    vars.org_uuid = this.vars.org_uuid;
    vars.company = U.id('companyDD').value;
    vars.companyBranch = U.id('compBranchDD').value;
    vars.orgType = U.id('orgTypeDD').value;
    vars.orgName = U.id('orgName').value;
    vars.regNumber = U.id('regNumber').value;

    vars.bAddress = U.id('bAddress').value;
    vars.bSuburb = U.id('bSuburb').value;
    vars.bTown = U.id('bTown').value;
    vars.bProvinceDD = U.id('bProvinceDD').value;
    vars.bArea = U.id('bArea').value;

    vars.pAddress = U.id('pAddress').value;
    vars.pSuburb = U.id('pSuburb').value;
    vars.pTown = U.id('pTown').value;
    vars.pProvinceDD = U.id('pProvinceDD').value;
    vars.pArea = U.id('pArea').value;

    vars.notes = U.id('textarea').value;

    O.PREP([await O.mPOST('organisation/upd-organisation', vars)])
      .then(async (res) => {
        const msg = res['organisation/upd-organisation'].status;
        comp.toast(msg);
        this.render();
      })
      .catch((err) => {
      });
  },
};
